import {
  getMergedEmbedOption,
  wistiaPlayerStyleBlock
} from "./chunk-KUPUTXLJ.mjs";

// src/WistiaPlayer.tsx
import { forwardRef, Suspense, lazy, Fragment } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var WistiaPlayerWrapper = lazy(
  async () => import("./WistiaPlayerWrapper-GRYNSUW5.mjs").then((module) => ({
    default: module.WistiaPlayerWrapper
  }))
);
var WistiaPlayer = forwardRef(
  (props, ref) => {
    const { aspect, embedHost, mediaId, swatch, style } = props;
    const finalEmbedHost = getMergedEmbedOption(mediaId, "embedHost", embedHost ?? void 0);
    const shouldDisplaySwatch = aspect !== void 0;
    const styleBlock = wistiaPlayerStyleBlock({
      mediaId,
      embedHost: finalEmbedHost,
      aspect,
      shouldLoadSwatch: swatch
    });
    return /* @__PURE__ */ jsx(
      Suspense,
      {
        fallback: shouldDisplaySwatch && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("style", { children: styleBlock }),
          /* @__PURE__ */ jsx("wistia-player", { "media-id": mediaId, style })
        ] }),
        children: /* @__PURE__ */ jsx(WistiaPlayerWrapper, { ref, ...props })
      }
    );
  }
);
export {
  WistiaPlayer
};
